export const SEARCH_DELAY_TIMER = 500; //ms
